const apis = require('./apis')
import {request, rjhySms, rjhyUser, rjhyCircle} from './request'
import gwRq from './requestGw'
const transformRequest = [(data) => {
  let ret = ''
  for (let it in data) {
    ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
  }
  return ret
}]

let headers = { 'Content-Type': 'application/x-www-form-urlencoded' }
let headersJson = {
  'Accept': 'application/json',
  'Content-Type': 'application/json'
}

const getKlineByHttp = async (params) => {
  return await request._get(apis.quote.getKline, params, true)
}

const getStockGene = async ({market, code}) => {
  return await request._get(apis.quote.gene, {market, symbol: code})
}

const getStockDetail = async ({market, code}) => {
  return await request._get(apis.quote.stockDetail, {market, symbol: code})
}

const getFdStockDetail = async ({market, code}) => {
  return await request._get(apis.quote.getFdStockDetail, {market, symbol: code})
}

const getBillData = async ({market, code}) => {
  return await request._get(apis.quote.getBillList, {num: '10000', symbol: `${market}${code}`})
}

const getStockProfile = async Ei => {
  return await request.post({url: request.apis.quote.getAShareProfile, params: {Ei}})
}

const setFreesend = async (params) => {
  headers = request.createSign(params)
  const res = await rjhySms.post(request.apis.sms.captcha, params, { headers, transformRequest })
  return res
}

const login = async(params) => {
  headers = request.createSign(params)
  const res = await rjhyUser.post(request.apis.user.login, params, { headers, transformRequest })
  return res
}
const publishDetail = async(params) => {
  headers = request.createSign(params)
  const res = await rjhyUser.post(request.apis.stockBar.publishDetail, params, { headers, transformRequest })
  return res
}
const supportReview = async(params) => {
  headers = request.createSign(params)
  const res = await rjhyUser.post(request.apis.stockBar.supportReview, params, { headers, transformRequest })
  return res
}
const unSupportReview = async(params) => {
  headers = request.createSign(params)
  const res = await rjhyUser.post(request.apis.stockBar.unSupportReview, params, { headers, transformRequest })
  return res
}
const support = async(params) => {
  headers = request.createSign(params)
  const res = await rjhyUser.post(request.apis.stockBar.support, params, { headers, transformRequest })
  return res
}
const unSupport = async(params) => {
  headers = request.createSign(params)
  const res = await rjhyUser.post(request.apis.stockBar.unSupport, params, { headers, transformRequest })
  return res
}
// 获取活动
const getActivity = async (params) => {
  return await request._get(apis.activity.activity, params, true, false, 'com.rjhy.activity.manage')
}
const getMultipleIndex = (params) => {
  return gwRq({
    method: 'get',
    url: `/api/1/multiple/index`,
    urlConfig: {
      requestKey: 'getMultipleIndex',
      domain: 'gwDomain',
      apiServer: 'rjhyQuotaIndex',
    },
    headers: {
      appcode: '9fztgw',
      appVersion: '3.15.2',
      clientType: 'h5',
      serverId: 200,
    },
    params,
    sign: true,
  })
}

export {
  getKlineByHttp,
  getStockGene,
  getStockDetail,
  getFdStockDetail,
  getBillData,
  getStockProfile,
  setFreesend,
  login,
  publishDetail,
  support,
  unSupport,
  supportReview,
  unSupportReview,
  getActivity,
  getMultipleIndex
}
